import React from 'react';
import {ListGroup} from 'react-bootstrap';

interface UploadedFilesListProps {
    uploadedFiles: File[];
    noFilesText: string;
    title: string;
}

const UploadedFilesList: React.FC<UploadedFilesListProps> = ({uploadedFiles, noFilesText, title}) => (
    <div className="d-flex flex-column gap-2">
        <span>
           {title}
        </span>
        <ListGroup>
            {uploadedFiles.length > 0 ? (
                uploadedFiles.map((file, index) => <ListGroup.Item key={index}>{file.name}</ListGroup.Item>)
            ) : (
                <ListGroup.Item>{noFilesText}</ListGroup.Item>
            )}
        </ListGroup>
    </div>
);

export default UploadedFilesList;
